/** @auther   : IBM  **/
/** @date     :  **/
<template>
  <el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="handleClose"
      class="f2f_dailog"
    >
      <template slot="title">
        <el-row>
          <span
            v-if="
              $root.f2fRealTimeTableData[index] &&
              $root.f2fRealTimeTableData[index].time
            "
            >{{ dialogTitle }} {{ $root.htmlConst.cons_137_call_time }}
            {{ $root.f2fRealTimeTableData[index].time }}</span
          >
          <span v-else style="min-width: 185px; float: left"
            >{{ dialogTitle }} {{ $root.htmlConst.cons_136_stop }}
          </span>
        </el-row>
        <hr style="color: #f8f8f8; opacity: 0.5" />
        <el-row>
          <el-input
            v-if="search != oldSearch"
            v-model="search"
            size="mini"
            :placeholder="$root.htmlConst.cons_140_input"
            clearable
            @keyup.enter.native="searchAllText('search')"
            style="width: 80%"
          ></el-input>
          <el-input
            v-else
            v-model="search"
            size="mini"
            :placeholder="$root.htmlConst.cons_140_input"
            clearable
            @keyup.enter.native="downSelect()"
            style="width: 80%"
          ></el-input>
          <el-button
            v-if="multipleSelection.length"
            type="info"
            @click="upSelect"
            icon="el-icon-caret-top"
            style="margin-left: 1%"
          ></el-button>
          <el-button
            v-else
            type="info"
            @click="upSelect"
            icon="el-icon-caret-top"
            style="margin-left: 1%"
            disabled
          ></el-button>
          <span
            v-if="search != '' && multipleSelection.length"
            style="padding: 0 1%"
            >{{ searchIndex }}/{{ multipleSelection.length }}</span
          >
          <span
            v-else-if="search != '' && multipleSelection.length == 0"
            style="padding: 0 1%"
            >0/0</span
          >
          <el-button
            v-if="multipleSelection.length"
            type="info"
            @click="downSelect"
            icon="el-icon-caret-bottom"
          ></el-button>
          <el-button
            v-else
            type="info"
            @click="downSelect"
            icon="el-icon-caret-bottom"
            disabled
          ></el-button>
        </el-row>
      </template>
      <section class="result-content">
        <el-table
          :data="allTextData"
          ref="multipleTable"
          :show-header="false"
          v-loading="loading"
          :element-loading-text="$root.htmlConst.cons_141_data_loading"
          element-loading-spinner="el-icon-loading"
          highlight-current-row
          v-chat-scroll
        >
          <template slot="empty">
            <p>{{ emptyText }}</p>
          </template>
          <el-table-column>
            <template slot-scope="scope">
              <div
                class="message_msg"
                :class="{
                  left: scope.row.flag == 'left',
                  right: scope.row.flag == 'right',
                }"
              >
                <div class="user_headshot">
                  <img
                    src="../../assets/operator.png"
                    v-if="scope.row.user == 'オペレーター'"
                  />
                  <img
                    src="../../assets/watson.gif"
                    v-else-if="scope.row.user == 'Watson'"
                  />
                  <img
                    src="../../assets/moppy1.png"
                    v-else-if="scope.row.user == 'もっぴー'"
                  />
                  <img src="../../assets/user_logo.png" v-else />
                  <!-- <img src="../assets/img/watson_think_stop.gif" v-else> -->
                </div>
                <div class="user_msg">
                  <div class="speaker" v-if="scope.row.user == 'Watson'">モッピー</div>
                  <div class="speaker" v-else>{{ scope.row.user }}</div>
                  <div class="user_text" v-html="scope.row.text"></div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </section>
    </el-dialog>
    <el-table
      v-if="$root.f2fTable"
      :data="$root.f2fRealTimeTableData"
      border
      stripe
      v-loading="realTimeloading"
      :element-loading-text="$root.htmlConst.cons_141_data_loading"
      element-loading-spinner="el-icon-loading"
      :height="$root.f2fTableHeight"
      style="overflow-y: hidden"
      class="detail-table f2f-table"
      :header-cell-style="{padding: '5px 0px'}"
    >
      <template slot="empty">
        <p>{{ emptyText }}</p>
      </template>
      <el-table-column
        key="2"
        prop="groupName"
        :label="$root.htmlConst.cons_113_table_header_group"
        style="float: left"
        :filters="$root.f2fRealTimeGroupFilters"
        :filter-method="filterGroup"
        filter-placement="bottom-end"
        width="90"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="19"
        prop="queueNum"
        :label="$root.htmlConst.cons_114_table_header_num"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="3"
        prop="operatorName"
        :label="$root.htmlConst.cons_115_table_header_user"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="20"
        prop="role"
        :label="$root.htmlConst.cons_116_table_header_sv"
        :filters="$root.f2fRealTimeSvFilters"
        :filter-method="filterSV"
        filter-placement="bottom-end"
        width="60"
        :resizable="false"
      ></el-table-column>
      <el-table-column
        key="4"
        :label="$root.htmlConst.cons_118_table_header_access"
        :filters="$root.f2fRealTimeStatusFilters"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
        width="110"
        :resizable="false"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.presence === $root.htmlConst.cons_164_status_f2f"
            style="background-color: #67c23a; color: #fff"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="
              scope.row.presence === $root.htmlConst.cons_165_status_online
            "
            style="background-color: #007bff; color: #fff"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="
              scope.row.presence === $root.htmlConst.cons_166_status_busy
            "
            style="background-color: #ffc107"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="
              scope.row.presence === $root.htmlConst.cons_167_status_away
            "
            style="background-color: #dddddd"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="
              scope.row.presence === $root.htmlConst.cons_168_status_offline
            "
            style="background-color: #888888; color: #fff"
            >{{ scope.row.presence }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        key="21"
        prop="svHelp"
        :label="$root.htmlConst.cons_122_table_header_help"
        :resizable="false"
      >
        <el-table-column
          key="99"
          :label="$root.htmlConst.cons_122_table_header_dependent"
          :resizable="false"
        >
          <template slot-scope="scope">
            <!-- <div
              v-if="scope.row.svhelpStatus != ''"
              style="background-color: #e0d7eb; color: #000;"
            > -->
            <div
              :style="{'background-color':scope.row.svhelpStatus=='onSupport'?'#e0d7eb':'', color:scope.row.svhelpStatus=='onSupport'?'#000':''}"
            >
              <span>{{ scope.row.svhelpRequestCount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          key="98"
          :label="$root.htmlConst.cons_122_table_header_support"
          :resizable="false"
        >
          <template slot-scope="scope">
             <el-button
              type="primary"
              v-if="scope.row.svhelpStatus == 'request' && $root.user.role === 'supervisor'"
              icon="el-icon-s-custom"
              style="background-color: #bbbbbb; border-color: #bbbbbb;"
              @click="svHelpClick(scope.row)"
            ></el-button>

            <el-tooltip placement="top" v-if="scope.row.svhelpStatus == 'onSupport'">
              <div slot="content">{{ scope.row.svhelperString }}</div>
              <el-button
                type="primary"
                icon="el-icon-s-custom"
                v-if="scope.row.svhelpStatus == 'onSupport' && 
                  ((scope.row.svhelperString.split(',')[scope.row.svhelpRequestCount - 1].replace(/\s+/g,'') == $root.user.name.replace(/\s+/g,''))
                  || scope.row.svhelpRequestCount == '' || scope.row.svhelpRequestCount == 0)"
                @click="resetSvHelpClick(scope.row)"
              ></el-button>
              <el-button
                type="primary"
                icon="el-icon-s-custom"
                v-if="scope.row.svhelpStatus == 'onSupport' &&  scope.row.svhelpRequestCount > 0 &&
                  scope.row.svhelperString.split(',')[scope.row.svhelpRequestCount - 1].replace(/\s+/g,'') != $root.user.name.replace(/\s+/g,'')"
                disabled
              ></el-button>
            </el-tooltip>

            <el-button
              type="primary"
              v-if="(scope.row.svhelpStatus == '' ) || (scope.row.svhelpStatus == 'request' && $root.user.role === 'operator')"
              icon="el-icon-s-custom"
              style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop"
              disabled
            ></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :label="$root.htmlConst.cons_119_table_header_monitor"
        v-if="$root.user.role === 'operator'"
        width="110"
        :resizable="false"
      >
        <el-table-column
          key="6"
          :label="$root.htmlConst.cons_121_table_header_text"
          width="110"
          :resizable="false"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.hasSVNameFlag === true">
              <div slot="content">{{ scope.row.svName }}</div>
              <el-button
                type="primary"
                v-if="scope.row.hasSVNameFlag === true"
                icon="el-icon-document"
                disabled
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              v-else-if="scope.row.hasSVNameFlag === false"
              icon="el-icon-document"
              style="background-color: #bbbbbb; border-color: #bbbbbb"
              disabled
            ></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        key="5"
        :label="$root.htmlConst.cons_119_table_header_monitor"
        :resizable="false"
        v-else
      >
        <el-table-column
          key="6"
          :label="$root.htmlConst.cons_121_table_header_text"
          :resizable="false"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.hasSVNameFlag === true">
              <div slot="content">{{ scope.row.svName }}</div>
              <el-button
                type="primary"
                v-if="scope.row.hasSVNameFlag === true"
                icon="el-icon-document"
                @click="viewAllText(scope.$index, scope.row)"
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              v-else-if="scope.row.hasSVNameFlag === false"
              icon="el-icon-document"
              @click="viewAllText(scope.$index, scope.row)"
              style="background-color: #bbbbbb; border-color: #bbbbbb"
            ></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        key="40"
        :label="$root.htmlConst.cons_152_table_header_word_count"
        :resizable="false"
      >
        <el-table-column
          key="41"
          :label="$root.htmlConst.cons_151_table_header_wowword"
          :resizable="false"
        >
          <el-table-column
            key="42"
            :label="$root.htmlConst.cons_125_table_header_watson"
            :resizable="false"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.f2fWowWordFlg === 'true'"
              >
                <div slot="content">{{ scope.row.f2fWowWords }}</div>
                <div
                  style="
                    background-color: #67c23a;
                    color: #000;
                    float: left;
                    width: 100%;
                  "
                  v-if="scope.row.f2fWowWordFlg === 'true'"
                >
                  <span>{{ scope.row.f2fWowWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.f2fWowWordCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          key="43"
          :label="$root.htmlConst.cons_126_table_header_ngword"
          :resizable="false"
        >
          <el-table-column
            key="44"
            :label="$root.htmlConst.cons_125_table_header_watson"
            :resizable="false"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.f2fNgWordFlg === 'true'"
              >
                <div slot="content">
                  {{ scope.row.f2fNgWords }}
                </div>
                <div
                  style="
                    background-color: #ffc107;
                    color: #000;
                    float: left;
                    width: 100%;
                  "
                  v-if="scope.row.f2fNgWordFlg === 'true'"
                >
                  <span>{{ scope.row.f2fNgWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.f2fNgWordCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          key="45"
          :label="$root.htmlConst.cons_150_table_header_ngmanner"
          :resizable="false"
        >
          <el-table-column
            key="46"
            :label="$root.htmlConst.cons_125_table_header_watson"
            :resizable="false"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.f2fNgMannerFlg === 'true'"
              >
                <div slot="content">{{ scope.row.f2fNgManners }}</div>
                <div
                  style="
                    background-color: #ffc107;
                    color: #000;
                    float: left;
                    width: 100%;
                  "
                  v-if="scope.row.f2fNgMannerFlg === 'true'"
                >
                  <span>{{ scope.row.f2fNgMannerCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.f2fNgMannerCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column
        key="13"
        :label="$root.htmlConst.cons_130_table_header_time"
        :resizable="false"
      >
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.time }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-else
      :data="$root.f2fDailyTableData"
      border
      stripe
      v-loading="dailyloading"
      :element-loading-text="$root.htmlConst.cons_141_data_loading"
      element-loading-spinner="el-icon-loading"
      :height="$root.f2fTableHeight"
      style="overflow-y: hidden"
      class="detail-table f2f-table"
      :header-cell-style="{padding: '5px 0px'}"
    >
      <template slot="empty">
        <p>{{ emptyText }}</p>
      </template>
      <el-table-column
        key="2"
        prop="groupName"
        :label="$root.htmlConst.cons_113_table_header_group"
        style="float: left"
        :filters="$root.f2fDailyGroupFilters"
        :filter-method="filterGroup"
        filter-placement="bottom-end"
        width="90"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="119"
        prop="queueNum"
        :label="$root.htmlConst.cons_114_table_header_num"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="3"
        prop="operatorName"
        :label="$root.htmlConst.cons_115_table_header_user"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="20"
        prop="role"
        :label="$root.htmlConst.cons_116_table_header_sv"
        :filters="$root.f2fDailySvFilters"
        :filter-method="filterSV"
        filter-placement="bottom-end"
        width="60"
        :resizable="false"
      ></el-table-column>
      <el-table-column
        key="70"
        prop="f2fDailyCount"
        :label="$root.htmlConst.cons_131_table_header_count"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        :label="$root.htmlConst.cons_132_table_header_daily_time"
        v-if="$root.dailyTimeFlg === '1'"
        :resizable="false"
      >
        <el-table-column
          key="71"
          :label="$root.htmlConst.cons_133_table_header_sum"
          prop="f2fDailyTime"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          key="72"
          :label="$root.htmlConst.cons_134_table_header_ave"
          prop="f2fDailyAverageTime"
          :resizable="false"
        >
        </el-table-column>
      </el-table-column>

      <el-table-column
        key="60"
        :label="$root.htmlConst.cons_152_table_header_word_rate"
        :resizable="false"
      >
        <el-table-column
          key="61"
          :label="$root.htmlConst.cons_151_table_header_wowword"
          :resizable="false"
        >
          <el-table-column
            key="62"
            :label="$root.htmlConst.cons_125_table_header_watson"
            prop="watsonWowWordRate"
            :resizable="false"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          key="63"
          :label="$root.htmlConst.cons_126_table_header_ngword"
          :resizable="false"
        >
          <el-table-column
            key="65"
            :label="$root.htmlConst.cons_125_table_header_watson"
            prop="watsonNgwordRate"
            :resizable="false"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          key="66"
          :label="$root.htmlConst.cons_150_table_header_ngmanner"
          :resizable="false"
        >
          <el-table-column
            key="67"
            :label="$root.htmlConst.cons_125_table_header_watson"
            prop="watsonNgMannerRate"
            :resizable="false"
          >
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :label="$root.htmlConst.cons_135_table_header_traffic"
        v-if="$root.dailySatisfactionIndex === 'display'"
        :resizable="false"
      >
        <el-table-column
          key="58"
          :label="$root.htmlConst.cons_125_table_header_watson"
          prop="watsonDailyFrequency"
          :resizable="false"
        >
        </el-table-column>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
import api from "@/api";
var moment = require("moment-timezone");
var sd = require("silly-datetime");
import { find } from "lodash";
export default {
  name: "F2FDetailTable",
  data() {
    return {
      emptyText: "",
      lockReconnect: false,
      allTextData: [],
      dialogTitle: "",
      dialogVisible: false,
      confirmDialogVisible: false,
      conUuid: "",
      search: "",
      oldSearch: "",
      loading: this.loading,
      realTimeloading: this.realTimeloading,
      dailyloading: this.dailyloading,
      dialogOperatorId: "",
      userTextInterval: "",
      timer: "",
      dialogTime: "",
      index: "",
      speechEmotionIndex: "",
      nameless: "",
      checkIndex: 0,
      searchIndex: 1,
      multipleSelection: [],
    };
  },
  created() {
    if (this.$root.user.user_id) {
      this.getF2FRealTimeTableDetail();
      this.getF2FDailyTableDetail();
    } else {
      api.getUserInfo().then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            this.$root.user = data.user;
            this.getF2FRealTimeTableDetail();
            this.getF2FDailyTableDetail();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  },
  mounted: function () {
    var _this = this;
    this.timer = setInterval(function () {
      for (let data of _this.$root.f2fRealTimeTableData) {
        if (data.answerTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(
              nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000
            ),
            "YYYY-MM-DD HH:mm:ss"
          );
          var answerTime = moment(
            new Date(
              data.answerTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, "")
            )
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hours = moment(time).diff(moment(answerTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              outTime = outTime + "0" + hours + ":";
            } else {
              outTime = outTime + hours + ":";
            }
          } else {
            outTime = outTime + "00:";
          }
          let minutes = moment(time).diff(moment(answerTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              outTime = outTime + "0" + minutes + ":";
            } else {
              outTime = outTime + minutes + ":";
            }
          } else {
            outTime = outTime + "00:";
          }
          let seconds =
            (moment(time).diff(moment(answerTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              outTime = outTime + "0" + seconds;
            } else {
              outTime = outTime + seconds;
            }
          } else {
            outTime = outTime + "00";
          }
          data.time = outTime;
        }
      }
    }, 1000);
  },
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    filterGroup(value, row) {
      return row.groupName === value;
    },
    filterSV(value, row) {
      return row.role === value;
    },
    filterStatus(value, row) {
      return row.presence === value;
    },
    getF2FRealTimeTableDetail: function () {
      this.realTimeloading = true;
      this.$root.isDataLoading = true
      api.getF2FRealTimeTableDetail(this.$root.user.user_id).then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            this.$root.f2fRealTimeTableData = data.output_list;
            for (let groupName of data.output_list.map((v) => v.groupName)) {
              let groupNameFilter = {};
              if (
                !this.$root.f2fRealTimeGroupFilters
                  .map((v) => v.value)
                  .includes(groupName)
              ) {
                groupNameFilter.text = groupName;
                groupNameFilter.value = groupName;
                this.$root.f2fRealTimeGroupFilters.push(groupNameFilter);
              }
            }
            for (let role of data.output_list.map((v) => v.role)) {
              let svFilter = {};
              if (
                !this.$root.f2fRealTimeSvFilters
                  .map((v) => v.value)
                  .includes(role)
              ) {
                svFilter.text = role;
                svFilter.value = role;
                this.$root.f2fRealTimeSvFilters.push(svFilter);
              }
            }
            for (let presence of data.output_list.map((v) => v.presence)) {
              let statusFilter = {};
              if (
                !this.$root.f2fRealTimeStatusFilters
                  .map((v) => v.value)
                  .includes(presence)
              ) {
                statusFilter.text = presence;
                statusFilter.value = presence;
                this.$root.f2fRealTimeStatusFilters.push(statusFilter);
              }
            }
            this.$root.f2fNgCount = data.ngCount;
            this.realTimeloading = false;
            this.$root.isDataLoading = false;

          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getF2FDailyTableDetail: function () {
      this.dailyloading = true;
      api.getF2FDailyTableDetail(this.$root.user.user_id).then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            this.$root.f2fDailyTableData = data.output_list;
            for (let groupName of data.output_list.map((v) => v.groupName)) {
              let groupNameFilter = {};
              if (
                !this.$root.f2fDailyGroupFilters
                  .map((v) => v.value)
                  .includes(groupName)
              ) {
                groupNameFilter.text = groupName;
                groupNameFilter.value = groupName;
                this.$root.f2fDailyGroupFilters.push(groupNameFilter);
              }
            }
            for (let role of data.output_list.map((v) => v.role)) {
              let svFilter = {};
              if (
                !this.$root.f2fDailySvFilters.map((v) => v.value).includes(role)
              ) {
                svFilter.text = role;
                svFilter.value = role;
                this.$root.f2fDailySvFilters.push(svFilter);
              }
            }
      this.dailyloading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    getUserAllText: function () {
      let _this = this;
      api.getUserAllText(this.dialogOperatorId).then(
        (res) => {
          if (res && res.data) {
            _this.allTextData = res.data.output_list;
            _this.searchAllText("load");
            if (!_this.search) {
              _this.$refs.multipleTable.bodyWrapper.scrollTop =
                _this.$refs.multipleTable.bodyWrapper.scrollHeight;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    viewAllText(index, row) {
      this.index = index;
      this.dialogVisible = true;
      this.allTextData = [];
      this.multipleSelection = [];
      let self = this;
      self.loading = true;
      this.dialogOperatorId = row.loginId;
      this.dialogTitle = row.operatorName;
      let data = {
        user_id: this.$root.user.user_id,
        operator_id: self.dialogOperatorId,
        svName: self.$root.user.name,
      };

      api.saveTextStatus(data).then(
        () => {
          self.getUserAllText();
          self.userTextInterval = window.setInterval(() => {
            setTimeout(self.getUserAllText(), 0);
          }, 5000);
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleClose() {
      let self = this;
      self.allTextData = [];
      self.search = "";
      self.oldSearch = "";
      self.multipleSelection = [];
      this.dialogVisible = false;
      clearInterval(this.userTextInterval);
      let data = {
        user_id: this.$root.user.user_id,
        operator_id: self.dialogOperatorId,
        svName: self.$root.user.name,
      };
      api.closeDialog(data).then(
        () => {},
        (err) => {
          console.log(err);
        }
      );
    },
    searchAllText(action) {
      if (action == "search") {
        this.searchIndex = 1;
        this.multipleSelection = [];
      }
      if (this.oldSearch) {
        for (let text of this.allTextData) {
          if (text.text.includes(this.oldSearch)) {
            text.text = text.text.replace(
              RegExp(
                '<span class="resultOn">' + this.oldSearch + "</span>",
                "g"
              ),
              this.oldSearch
            );
            text.text = text.text.replace(
              RegExp(
                '<span class="resultOff">' + this.oldSearch + "</span>",
                "g"
              ),
              this.oldSearch
            );
          }
        }
      }
      if (this.search) {
        let tmpmultipleSelection = [];
        let allCount = 0;
        for (var i = 0; i < this.allTextData.length; i++) {
          let count = 0;
          if (this.allTextData[i].text.includes(this.search)) {
            this.allTextData[i].text = this.allTextData[i].text.replace(
              RegExp(this.search, "g"),
              '<span class="resultOn">' + this.search + "</span>"
            );
            count = this.allTextData[i].text.split(this.search).length - 1;
          }
          for (var j = 1; j <= count; j++) {
            let data = {
              rowIndex: i,
              rowSearchIndex: j,
              searchIndex: allCount + j,
            };
            tmpmultipleSelection.push(data);
          }
          allCount = allCount + count;
        }
        this.multipleSelection = tmpmultipleSelection;
        if (this.multipleSelection.length > 0) {
          const item = find(this.multipleSelection, {
            searchIndex: this.searchIndex,
          });
          let rowContentList = this.allTextData[item.rowIndex].text.split(
            this.search
          );
          let newContent = "";
          for (var m = 0; m < rowContentList.length; m++) {
            if (m == item.rowSearchIndex - 1) {
              newContent =
                newContent +
                rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
            } else {
              newContent = newContent + rowContentList[m];
            }
            if (m != rowContentList.length - 1) {
              newContent = newContent + this.search;
            }
          }
          this.allTextData[item.rowIndex].text = newContent;

          this.setCurrentRow(item.rowIndex);
        }
      }
      this.oldSearch = this.search;
    },
    downSelect() {
      for (let text of this.allTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      if (this.searchIndex >= this.multipleSelection.length) {
        this.searchIndex = 1;
      } else {
        this.searchIndex += 1;
      }
      const item = find(this.multipleSelection, {
        searchIndex: this.searchIndex,
      });
      let rowContentList = this.allTextData[item.rowIndex].text.split(
        this.search
      );
      let newContent = "";
      for (var m = 0; m < rowContentList.length; m++) {
        if (m == item.rowSearchIndex - 1) {
          newContent =
            newContent +
            rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
        } else {
          newContent = newContent + rowContentList[m];
        }
        if (m != rowContentList.length - 1) {
          newContent = newContent + this.search;
        }
      }
      this.allTextData[item.rowIndex].text = newContent;
      this.setCurrentRow(item.rowIndex);
    },
    upSelect() {
      for (let text of this.allTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      if (this.searchIndex == 1) {
        this.searchIndex = this.multipleSelection.length;
      } else {
        this.searchIndex -= 1;
      }
      const item = find(this.multipleSelection, {
        searchIndex: this.searchIndex,
      });
      let rowContentList = this.allTextData[item.rowIndex].text.split(
        this.search
      );
      let newContent = "";
      for (var m = 0; m < rowContentList.length; m++) {
        if (m == item.rowSearchIndex - 1) {
          newContent =
            newContent +
            rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
        } else {
          newContent = newContent + rowContentList[m];
        }
        if (m != rowContentList.length - 1) {
          newContent = newContent + this.search;
        }
      }
      this.allTextData[item.rowIndex].text = newContent;
      this.setCurrentRow(item.rowIndex);
    },
    setCurrentRow(index) {
      if (this.multipleSelection.length == 0) {
        return false;
      } else {
        const targetTop = this.$refs.multipleTable.$el
          .querySelectorAll(".el-table__body tr")[index].getBoundingClientRect().top;
        const containerTop = this.$refs.multipleTable.$el
          .querySelector(".el-table__body")
          .getBoundingClientRect().top;
        const scrollParent = this.$refs.multipleTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
        let scrollHeight = targetTop - containerTop;
        scrollParent.scrollTop = scrollHeight;
      }
    },
    svHelpClick(row) {
       api.svhelpOnSupport("STAND_MIC_MODE",row.operatorId,this.$root.user.user_id, '').then(
        (res) => {
          if (res && res.data) {
            console.log("svhelpOnSupport success");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    resetSvHelpClick(row) {
      api.resetSvhelpOnSupport("STAND_MIC_MODE",row.operatorId,this.$root.user.user_id,'').then(
        (res) => {
          if (res && res.data) {
            console.log("svhelpOnSupport reset success");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>

<style>
.f2f_dailog .el-dialog__header {
  background-color: #0086B5;
  color: #FFFFFF;
}
.f2f-table thead.is-group th {
  background-color:#0086B5 !important;
}
</style>
